export const MY_DOCUMENTS = [
    { 
        name: 'Design Reports (Canva)', 
        url: 'https://www.canva.com/design/DAG44kBXAFQ/uCvk8T_BQPCEQI1sqDEAJA/edit?utm_content=DAG44kBXAFQ&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton',
        type: 'design'
    },
    { 
        name: 'System Documentation', 
        url: 'https://drive.google.com/file/d/1_KpM5-nWD5nlT6NH6zv1DvnxHVqdEYIl/view?usp=sharing',
        type: 'technical'
    },
    { 
        name: 'Word Docs', 
        url: 'https://drive.google.com/file/d/17yBu2BMdLxUhUzMaqk3RxRNopRG7brS6/view?usp=sharing',
        type: 'technical'
    }
];
